// Widget Scripts
import slider from './js/widgets/slider';
import hotButtons from './js/widgets/hotButtons';
import multiScheduleFeature from './js/widgets/multiScheduleFeature';
import suscribeWidget from './js/widgets/suscribeWidget';

// Custom Theme Scripts
import './js/localjs';

let currentViewport = '';

function showHotButtons() {
  const newViewport = window.innerWidth <= 990 ? 'small' : 'large';

  if (newViewport !== currentViewport) {
    $('#hotButtonsWidget').empty().css('display', 'none');

    if (newViewport === 'small') {
      $('#hotButtonsWidget').css('display', 'flex');
      hotButtons();
    }

    currentViewport = newViewport;
  }

  return newViewport === 'small';
}

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(() => {
    slider();
    suscribeWidget();
    multiScheduleFeature();
    showHotButtons();
  });
  $(window).resize(() => {
    showHotButtons();
  });
}
